<template>
  <div class="UpdateData">
    <div class="tit">
      <p><i class="iconfont icon-gengxin3"></i>{{$t("DataServer.recentUpdates")}}</p>
    </div>
    <swiper :options="swiperOption" ref="mySwiper3">
      <swiper-slide
        v-for="(item, index) in lastUpdateDataSat.slice(0, 6)"
        :key="index"
      >
      <!-- .lastUpdateDataSat.slice(0, 6) -->
        <div class="sdg_box" @click="toDetails(item)">
          
          <!-- <img
            class="banner_img"
            :src="require(`@/assets/image/DataHub/data_1.png`)"
            alt="image"
          /> -->
          <img
            class="banner_img"
            :src="`${GLOBAL.imageUrl}${item.image}`"
            alt
          />
            <p>{{ item.productName }}</p>
              <span>{{ item.createInsti }} </span>
              <span class="updateTime">{{item.updateTime}}</span>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-button-prev">
      <i class="iconfont icon-jiantou2"></i>
    </div>
    <div class="swiper-button-next">
      <i class="iconfont icon-jiantou"></i>
    </div>
  </div>
</template>

<script>
// 引入插件
import { mapMixin } from "@/util/mixin";
import { swiper, swiperSlide, Pagination } from "vue-awesome-swiper";
import {
  swiperAnimateCache,
  swiperAnimate,
} from "@/assets/js/swiper.animate1.0.3.min.js";
import { lastUpdateDataSat } from "@/axios/datashare.js";
import "swiper/dist/css/swiper.css";
export default {
  mixins: [mapMixin],
  name: "Home",
  components: {
    swiper,
    swiperSlide,
    Pagination,
  },
  data() {
    return {
      lastUpdateDataSat: null,
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          init: function () {
            swiperAnimateCache(this);
            swiperAnimate(this);
          },
          slideChangeTransitionStart: function () {},
          slideChangeTransitionEnd: function () {},
          slideChange: function () {
            swiperAnimate(this);
          },
        },
      },
    };
  },
  methods: {
    toDetails(obj){
        this.$router.push(`/datadetails?dataId=${obj.dataId}`);
    },
    // 最近更新数据集
    async getLastUpdateDataSat() {
      return await lastUpdateDataSat();
    },
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper2.swiper;
    // },
  },
  mounted() {
    this.getLastUpdateDataSat().then((res) => {
      console.log(res.data.data);

      this.lastUpdateDataSat = res.data.data;

      // this.$nextTick(function(){
      //   console.log(  this.$refs.mySwiper2)

        
      // })
            // console.log(   this.lastUpdateDataSat.slice(0,6) )
    });
  },
};
</script>

<style lang="scss" >
@media screen and (min-width: 1026px) {
  .UpdateData {
    border-radius: 8px;
    width: 100%;
    padding: 24px 34px;
    margin: 20px auto;
    position: relative;
    overflow: hidden;
    background: #fff;
    height: 312px;
    .tit {
      margin-bottom: 16px;
      font-weight: 600;
      color: #000;
      font-size: 22px;
      i {
        color: #ff952c;
        margin-right: 10px;
        font-weight: 600;
        font-size: 22px;
      }
    }
    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      background: none;
      display: flex;
      align-items: center;
    }
    .swiper-button-prev {
      left: 0px;
      i {
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
      }
    }
    .swiper-button-next {
      right: -12px;
      i {
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
      }
    }
    .swiper-button-prev {
      left: 0px;
      top: 160px;
      i {
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
        background: rgba(230, 230, 230, 1);
        padding: 10px 10px 10px 2px;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        color: #fff;
      }
    }
    .swiper-button-next {
      right: -2px;
      top: 160px;
      i {
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
        background: rgba(230, 230, 230, 1);
        padding: 10px 4px 10px 10px;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        color: #fff;
      }
    }
    .swiper-container {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    .sdg_box {
      width: 100%;
      border-radius: 3px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      cursor: pointer;
      &:hover .banner_img{
        transition: .2s;
        transform: scale(1.1);
             border-radius: 4px;
      }
      &:hover p{
        color: #d8b879;
      }
      .banner_img {
          transition: .2s;
        overflow: hidden;
        object-fit: cover;
        width: 100%;
        height: 155px;
        border-radius: 4px;
        .updateTime{
          font-size: 12px;
        }
      }
      p {
        width: 100%;
        font-weight: 600;
        margin-top: 10px;
        font-size: 14px;
        color: #000;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      span {
             width: 100%;
        margin-top: 6px;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
     color: #000;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .UpdateData {
    border-radius: 8px;
    width: 100%;
    padding: 24px 34px;
    margin: 20px auto;
    position: relative;
    overflow: hidden;
    background: #fff;
    height: 312px;
    .tit {
      margin-bottom: 16px;
      font-weight: 600;
      color: #000;
      font-size: 22px;
      i {
        color: #ff952c;
        margin-right: 10px;
        font-weight: 600;
        font-size: 22px;
      }
    }
    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      background: none;
      display: flex;
      align-items: center;
    }
    .swiper-button-prev {
      left: 0px;
      i {
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
      }
    }
    .swiper-button-next {
      right: -12px;
      i {
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
      }
    }
    .swiper-button-prev {
      left: 0px;
      top: 160px;
      i {
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
        background: rgba(230, 230, 230, 1);
        padding: 10px 10px 10px 2px;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        color: #fff;
      }
    }
    .swiper-button-next {
      right: -2px;
      top: 160px;
      i {
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
        background: rgba(230, 230, 230, 1);
        padding: 10px 4px 10px 10px;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        color: #fff;
      }
    }
    .swiper-container {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    .sdg_box {
      width: 100%;
      border-radius: 3px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      cursor: pointer;
      &:hover .banner_img{
        transition: .2s;
        transform: scale(1.1);
             border-radius: 4px;
      }
      &:hover p{
        color: #d8b879;
      }
      .banner_img {
          transition: .2s;
        overflow: hidden;
        object-fit: cover;
        width: 100%;
        height: 155px;
        border-radius: 4px;
        .updateTime{
          font-size: 12px;
        }
      }
      p {
        width: 100%;
        font-weight: 600;
        margin-top: 10px;
        font-size: 14px;
        color: #000;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      span {
             width: 100%;
        margin-top: 6px;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
     color: #000;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}
</style>